<template>
  <div class="home">
    <!-- 轮播图 -->
    <div class="block">
      <el-carousel height="40rem">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <img lazy class="img" :src="img_api + item.image" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 交通建设行业服务商 -->
    <div class="service">
      <div class="service_title">交通建设行业服务商</div>
      <div class="service_des">以提高客户满意度为目标·为客户提供优质的</div>
      <div class="rowline"></div>
      <div>
        <ul class="options">
          <li>
            <div>
              <img src="../assets/img/132x132_sale@2x.png" />
            </div>
            <div class="option_front">销售</div>
          </li>
          <li>
            <div>
              <img src="../assets/img/132x132_zulin@2x.png" />
            </div>
            <div class="option_front">租赁</div>
          </li>
          <li>
            <div>
              <img src="../assets/img/132x132_weixiu@2x.png" />
            </div>
            <div class="option_front">维修</div>
          </li>
          <li>
            <div>
              <img src="../assets/img/132x132_shigong@2x.png" />
            </div>
            <div class="option_front">施工</div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 关于我们 -->
    <div class="about_me">
      <div class="about_content">
        <div class="about_imgBox">
          <el-image
            lazy
            :src="img_api + aboutMeData.image"
            alt=""
            class="about_img"
          />
        </div>
        <div class="about_right">
          <div class="about_title" @click="toAbout">
            <span class="cn_title">{{ aboutMeData.title }}</span>
            <span class="en_title">/ About us</span>
          </div>
          <div class="about_des" v-html="aboutMeData.details"></div>
          <button class="lookdes_button" @click="toAbout()">查看详情>></button>
        </div>
      </div>
    </div>

    <!-- 新闻资讯 -->
    <div class="news">
      <div class="service_title">新闻资讯</div>
      <div class="service_des">NEWS INFORMATION</div>
      <div class="rowline"></div>
      <div class="news_box">
        <div class="box_left">
          <div class="news_option" @click="toEnterprisePage">企业新闻 ></div>
          <div
            class="new"
            v-for="item in enterprisePage"
            :key="item.id"
            @click="toNews(item.id)"
          >
            <div class="news_imgbox">
              <el-image
                lazy
                class="news_img"
                :src="img_api + item.image"
                alt=""
              />
            </div>
            <div class="news_content">
              <div class="news_title">
                {{ item.name }}
              </div>
              <div class="news_des">
                {{ item.brief }}
              </div>
            </div>
          </div>
        </div>
        <div class="box_right">
          <div class="news_option" @click="toIndustryPage">行业资讯 ></div>
          <div
            class="new"
            v-for="item in industryPage"
            :key="item.id"
            @click="toNews(item.id)"
          >
            <div class="news_imgbox">
              <el-image
                lazy
                class="news_img"
                :src="img_api + item.image"
                alt=""
              />
            </div>
            <div class="news_content">
              <div class="news_title">
                {{ item.name }}
              </div>
              <div class="news_des">
                {{ item.brief }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="more" @click="toNesMore">MORE+</div>
    </div>

    <!-- 产品中心 -->
    <div class="products_box">
      <div class="service_title">产品中心</div>
      <div class="service_des">OUR ADVANTAGES</div>
      <div class="rowline"></div>
      <div class="bigProducts">
        <ul class="products">
          <!-- 这里id不知道对不对 -->
          <li v-for="item in goods" :key="item.id">
            <div class="imgBox" @click="toGoodsDetail(item.id)">
              <el-image
                lazy
                class="product_img"
                :src="img_api + item.images[0]"
                alt=""
              />
            </div>
            <div class="product_bottom">
              <div class="blue_font">{{ item.englishName }}</div>
              <div class="product_title">{{ item.name }}</div>
            </div>
          </li>
        </ul>
      </div>

      <div class="products_buttonBox">
        <button class="product_button" @click="toProduct">
          点击了解更多
          <div class="click_box">
            <img src="../assets/img/24x24_dianji@2x.png" alt="" />
          </div>
        </button>
      </div>
    </div>

    <!-- 业务板块 -->
    <div
      class="business"
      :style="{
        backgroundImage: 'url(' + img_api + contactData.image + ')',
        backgroundSize: '100% 100%',
      }"
    >
      <div class="business_title">业务板块</div>
      <div class="business_title business_en_title">BUSINESS SEGMENT</div>
      <div
        class="box business_page"
        v-for="item in headList"
        @mouseover="NO = item.id"
        @mouseleave="NO = ''"
        :key="item.id"
      >
        <div class="box_title" v-show="NO != item.id">{{ item.name }}</div>
        <div class="box2 button_page" v-show="NO == item.id">
                 
          <div class="button_page_title">{{ item.name }}</div>
                 
          <div class="button_page_line"></div>
                 
          <div class="button_page_des">
                      {{ item.details }}        
          </div>
                 
          <button class="button_page_button" @click="toSegment(item.type)">
            查看详情
          </button>
               
        </div>
      </div>
    </div>
    <!-- 授权证书 -->
    <div class="certificate_page">
      <div class="honor_title">
        <div class="certificate_en_title">CERTIFICATE OF HONORS</div>
        <div class="certificate_cn_title">荣誉证书</div>
        <div class="rowline"></div>
        <div class="certificate_des">选择远沃 选择品质</div>
      </div>
      <div class="certificate_box">
        <div class="certificates">
          <div class="row1">
            <div class="row" v-for="item in row1" :key="item.id">
              <el-image
                lazy
                :src="img_api + item.image"
                class="friend_el-image"
              >
                <div slot="placeholder" class="image-slot">
                  加载中...
                </div></el-image
              >
            </div>
          </div>

          <div class="row2">
            <div class="row" v-for="item in row2" :key="item.id">
              <el-image
                lazy
                :src="img_api + item.image"
                class="friend_el-image"
              >
                <div slot="placeholder" class="image-slot">
                  加载中...
                </div></el-image
              >
            </div>
          </div>
          <div class="row3">
            <div class="row_tall" v-for="item in row3" :key="item.id">
              <el-image lazy :src="img_api + item.image" class="row_tall_img">
                <div slot="placeholder" class="image-slot">
                  加载中...
                </div></el-image
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 公司荣誉 -->
    <div class="honor_page">
      <div class="honors">
        <!-- 第一行 -->
        <div class="rows">
          <!-- 证书图片 -->
          <div class="honor1">
            <div
              class="row1_imgbox"
              v-for="(item, index) in honor_row1"
              :key="item.id"
            >
              <el-image
                lazy
                :src="img_api + item.image"
                alt=""
                class="row1_imgbox_img"
              >
                <div slot="placeholder" class="image-slot">
                  加载中...
                </div></el-image
              >
            </div>
          </div>
          <!-- 架子图片 -->
          <img
            class="row1_img"
            src="../assets/img/bg_honor_desk_1.png"
            alt=""
          />
        </div>
        <!-- 第二行 -->
        <div class="rows">
          <!-- 架子图片 -->
          <img
            class="row2_img"
            src="../assets/img/bg_honor_desk_2.png"
            alt=""
          />
          <!-- 证书图片 -->
          <div class="honor2">
            <div
              class="row1_imgbox"
              v-for="(item, index) in honor_row2"
              :key="item.id"
            >
              <el-image
                lazy
                :src="img_api + item.image"
                class="row1_imgbox_img"
                alt=""
              >
                <div slot="placeholder" class="image-slot">
                  加载中...
                </div></el-image
              >
            </div>
          </div>
        </div>
        <!-- 第三行 -->
        <div class="rows">
          <!-- 架子图片 -->
          <img
            class="row3_img"
            src="../assets/img/bg_honor_desk_3.png"
            alt=""
          />
          <!-- 证书图片 -->
          <div class="honor3">
            <div
              class="row1_imgbox"
              v-for="(item, index) in honor_row3"
              :key="item.id"
            >
              <el-image
                lazy
                :src="img_api + item.image"
                alt=""
                class="row1_imgbox_img"
              >
                <div slot="placeholder" class="image-slot">
                  加载中...
                </div></el-image
              >
            </div>
          </div>
        </div>
        <!-- 第四行 -->
        <div class="rows" style="margin-top: 5%">
          <!-- 架子图片 -->
          <img
            class="row4_img"
            src="../assets/img/bg_honor_desk_4.png"
            alt=""
          />
          <!-- 证书图片 -->
          <div class="honor4">
            <div
              class="row4_imgbox"
              v-for="(item, index) in honor_row4"
              :key="item.id"
            >
              <el-image
                lazy
                :src="img_api + item.image"
                alt=""
                class="honor_tall_img"
              >
                <div slot="placeholder" class="image-slot">
                  加载中...
                </div></el-image
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 合作伙伴 -->
    <div class="friends">
      <div class="service_title">合作伙伴</div>
      <div class="service_des">OUR PARTINERS</div>
      <div class="rowline"></div>
      <div class="friends_box">
        <div
          class="friend_sort friend_base"
          v-for="item in partners"
          :key="item.id"
        >
          <el-image
            lazy
            fit="contain"
            :src="img_api + item.image"
            alt=""
            class="friend_sort_img"
          />
        </div>
      </div>
    </div>
    <!-- 客服热线 -->
    <div class="call">
      <div class="callleft_content">
        <div class="call_title">进一步了解适合您的最佳解决方案</div>
        <button class="call_button call_left_button" @click="toContact">
          咨询客服
        </button>
      </div>
      <!-- 联系我们 -->
      <div class="callright_content">
        <div class="call_title">客服热线：020-85165995</div>
        <a href="tel:020-85165995"
          ><button class="call_button call_right_button">立即咨询</button></a
        >
      </div>
    </div>
  </div>
</template>

<script>
import api from "../config";
import {
  getHomeData,
  getAboutMeData,
  getHomeProducts,
  getGoodPage,
  getPartners,
  getCertificate,
  getHomeNews,
  getHeadBanner,
  getContactUs,
} from "@/server/https.js";
const https = require("../../vue.config");
export default {
  name: "",
  data() {
    return {
      NO: "",
      smallClient: "",
      bannerList: [],
      enterprisePage: [],
      industryPage: [],
      friendSortList: [],
      headList: [],
      cers: [],
      honors: [],
      //产品中心
      goods: [],
      //证书
      Certificates: [],
      //合作伙伴
      partners: [],
      information_active: 0, //新闻动态索引
      carouselIndex: 0, //轮播图索引
      carouselProductIndex: 0, //核心产品索引
      brandList: [],
      api: "",
      img_api: "",
      aboutMeData: "",
      pageNo: 1,
      pageSize: 6,
      contactData: {},
    };
  },
  computed: {
    row1() {
      let row_1 = this.cers.filter((item) => item.height == 1);
      row_1.sort((a, b) => a.sort - b.sort);
      return row_1;
    },
    row2() {
      let row_2 = this.cers.filter((item) => item.height == 2);
      row_2.sort((a, b) => a.sort - b.sort);
      return row_2;
    },
    row3() {
      let row_3 = this.cers.filter((item) => item.height == 3);
      row_3.sort((a, b) => a.sort - b.sort);
      return row_3;
    },
    honor_row1() {
      let honor_1 = this.honors.filter((item) => item.height == 1);
      honor_1.sort((a, b) => a.sort - b.sort);
      return honor_1;
    },
    honor_row2() {
      let honor_2 = this.honors.filter((item) => item.height == 2);
      honor_2.sort((a, b) => a.sort - b.sort);
      return honor_2;
    },
    honor_row3() {
      let honor_3 = this.honors.filter((item) => item.height == 3);
      honor_3.sort((a, b) => a.sort - b.sort);
      return honor_3;
    },
    honor_row4() {
      let honor_4 = this.honors.filter((item) => item.height == 4);
      honor_4.sort((a, b) => a.sort - b.sort);
      return honor_4;
    },
  },

  mounted() {
    this.api = api.api;
    this.img_api = api.img_api;
    window.scrollTo(0, 0); // 滚动到页面顶部
    getHomeData().then((res) => {
      res.data.body.bannerList.sort((a, b) => a.sort - b.sort);
      this.bannerList = res.data.body.bannerList;
      var brandList = res.data.body.brandList;
      var brandListTemp = [];
      brandList.map((item) => {
        if (item.yesNo == 1) {
          brandListTemp.push(item);
        }
      });
      this.brandList = brandListTemp;
    });
    getAboutMeData().then((res) => {
      this.aboutMeData = res.data.body.contactUs;
    });
    getHeadBanner().then((res) => {
      res.data.body.headList.filter((item) => {
        // 判断 name 字段是否包含指定字符串，如果包含则将该对象存储到新数组中
        if (item.name.includes("业务")) {
          this.headList.push(item);
        }
      });
    }),
      getHomeProducts().then((res) => {
        this.products = res.data.body;
      }),
      getGoodPage({ pageNo: 1, pageSize: 6 }).then((res) => {
        res.data.body.page.list.sort((a, b) => a.sort - b.sort);
        this.goods = res.data.body.page.list;
      }),
      getPartners().then((res) => {
        res.data.body.list.sort((a, b) => a.sort - b.sort);
        this.partners = res.data.body.list;
      }),
      getCertificate({ type: 2 }).then((res) => {
        this.cers = res.data.body.list;
      }),
      getCertificate({ type: 1 }).then((res) => {
        this.honors = res.data.body.list;
      }),
      getHomeNews().then((res) => {
        res.data.body.enterprisePage.sort((a, b) => a.sort - b.sort);
        this.enterprisePage = res.data.body.enterprisePage.slice(0, 3);
        res.data.body.industryPage.sort((a, b) => a.sort - b.sort);
        this.industryPage = res.data.body.industryPage.slice(0, 3);
      });
    getContactUs().then((res) => {
      this.contactData = res.data.body.contactUs;
    });
  },
  methods: {
    toGoodsDetail(id) {
      this.$router.push({
        path: "/tradeDetail",
        query: {
          goodId: id,
        },
      });
    },
    toEnterprisePage() {
      this.$router.push({
        path: "/news",
        query: {
          tabIndex: 1,
        },
      });
    },
    toIndustryPage() {
      this.$router.push({
        path: "/news",
        query: {
          tabIndex: 2,
        },
      });
    },
    toContact() {
      this.$router.push({
        path: "/contact",
      });
    },
    toSegment(type) {
      if (type == "3") {
        this.$router.push({
          path: "/trade",
        });
      } else if (type == "4") {
        this.$router.push({
          path: "/market",
        });
      } else if (type == "6") {
        this.$router.push({
          path: "/operation",
        });
      } else if (type == "7") {
        this.$router.push({
          path: "/build",
        });
      }
    },
    toProduct() {
      this.$router.push({
        path: "/trade",
      });
    },
    toAbout() {
      this.$router.push({
        path: "/about",
      });
    },
    toNesMore() {
      this.$router.push({
        path: "/news",
        query: {
          tabIndex: 0,
        },
      });
    },
    toNews(id) {
      this.$router.push({
        name: "NewsDetail",
        query: {
          newsId: id,
        },
      });
    },
  },
};
</script>

<style scoped>
.home {
  /* min-width: 88.5rem; */
}

.img {
  width: 100%;
  height: 100%;
}

.block {
  /* height: 3.125rem;  */
}

.service {
  height: 30rem;
  /* 30rem * 16px = 480px */
  display: flex;
  align-items: center;
  flex-direction: column;
}

.service_title {
  display: flex;
  margin-top: 4.25rem;
  justify-content: center;
  font-weight: 500;
  color: #333333;
  font-size: 1.625rem;
}

.service_des {
  justify-content: center;
  display: flex;
  margin-top: 1rem;
  /* 40px / 16px = 2.5rem */
  color: #999999;
  font-size: 1.25rem;
  /* 20px / 16px = 1.25rem */
}

.rowline {
  width: 2rem;
  /* 2px / 16px = 0.125rem */
  height: 0.25rem;
  /* 1px / 16px = 0.0625rem */
  background: #13489d;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
  /* 1px / 16px = 0.0625rem */
}

.options {
  width: 70.5rem;
  /* 70.75rem * 16px = 1132px */
  margin-top: 4.38rem;
  /* 70px / 16px = 4.375rem */
  display: flex;
  justify-content: space-around;
}

.options li div {
  display: flex;
  justify-content: center;
}

.options li div img {
  width: 8.25rem;
  height: 8.25rem;
}

.option_front {
  text-align: center;
  margin-top: 0.625rem;
  /* 10px / 16px = 0.625rem */
  color: #333333;
  font-size: 1.25rem;
  /* 20px / 16px = 1.25rem */
  font-weight: bold;
}

/* 关于我们 */
.about_me {
  overflow: hidden;
  background-color: #f7f8fa;
  height: 24rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.about_content {
  display: flex;
  height: 21.5rem;
  align-items: center;
}

.about_imgBox {
  /* margin-left: 15rem; */
  width: 27.38rem;
  height: 17.5rem;
  margin-right: 0.2083rem;
}

.about_img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.about_right {
  display: flex;
  flex-direction: column;
  width: 36rem;
  height: 17.125rem;
  margin-left: 2rem;
  position: relative;
}

.cn_title {
  font-weight: bold;
  color: #333333;
  font-size: 1.5rem;
  /* 24px / 16px = 1.5rem */
}

.en_title {
  font-size: 1.55rem;
  /* 20px / 16px = 1.25rem */
  margin-bottom: 0.6944rem;
  /* 11.1% / 16px = 0.6944rem */
  color: #999999;
  display: flex;
  margin-left: 0.5px;
}

.about_des {
  font-size: 1rem;
  /* 16px / 16px = 1rem */
  /* width: 10rem; */
  /* 改为10rem */
  line-height: 1.4;
  white-space: pre-wrap;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
}

.about_title {
  display: flex;
  flex-direction: row;
  cursor: pointer;
}

.lookdes_button {
  position: absolute;
  bottom: -6px;
  width: 8.75rem;
  height: 2.5rem;
  background: #13489d;
  font-size: 1rem;
  font-weight: 400;
  color: #ffffff;
  border: none;
}

.products_box {
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #f7f8fa;
}
.bigProducts{
  width:1100px;
  display: flex;
  justify-content: center;
}
.products {
  display: flex;
  flex-wrap: wrap;
  margin-top: 26px;
  /* justify-content: center; */
}

.products li {
  margin-top: 3%;
  margin-left: 1.3%;
  width: 22rem;
  height: 22rem;
  box-shadow: 4px 6px 16px 4px rgba(0, 0, 0, 0.1);
}

.imgBox {
  width: 94%;
  height: 75.3%;
  margin: 3%;
  cursor: pointer;
  /* border-bottom: 1px solid #C8D4E1; */
}

.product_img {
  width: 100%;
  height: 100%;
  display: flex;
}

.product_bottom {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 17.44%;
  border-top: 1px solid #c8d4e1;
}

.blue_font {
  font-size: 16px;
  font-weight: bold;
  color: #13489d;
  border-bottom: 4px solid #ffd000;
}

.product_title {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-left: 2%;
}

.product_button {
  display: flex;
  justify-content: center;
  width: 12.625rem;
  height: 4rem;
  background: #13489d;
  font-weight: 400;
  color: #ffffff;
  line-height: 64px;
  border: none;
  margin-top: 3.5rem;
  margin-bottom: 2rem;
}

.business {
  position: relative;
  height: 56.25rem;
  width: 75rem;
  display: flex;
  margin: auto;
}

.business_title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  margin-top: 7.0625rem;
  font-size: 3rem;
  color: #ffffff;
  z-index: 2;
}

.button_page {
  background: linear-gradient(180deg, rgba(19, 72, 157, 0.4) 0%, #13499d 100%);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.box {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: end;
  flex: 1;
  /* Internet Explorer 10 */
  display: -ms-flexbox;
  -ms-flex-pack: center;
  -ms-flex-align: end;

  /* Firefox */
  display: -moz-box;
  -moz-box-pack: center;
  -moz-box-align: end;

  /* Safari, Chrome, and Opera */
  display: -webkit-box;
  -webkit-box-pack: center;
  -webkit-box-align: end;

  /* W3C */
  display: box;
  box-pack: center;
  box-align: end;
}

.box::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 0.125rem;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    #ffffff 100%
  );
}

.box_title {
  display: flex;
  justify-content: center;
  height: 3.375rem;
  margin-bottom: 2.5rem;
  padding: 0.3125rem;
  border-bottom: 0.125rem solid #ffffff;
  align-items: end;
  font-size: 1.575rem;
  color: #ffffff;
}

.business_en_title {
  color: rgba(255, 255, 255, 0.4);
}

.button_page_title {
  position: absolute;
  top: 16.25rem;
  text-align: center;
  font-size: 1.875rem;
  color: #ffffff;
}

.button_page_line {
  display: flex;
  position: absolute;
  top: 23.5rem;
  justify-content: center;
  width: 2rem;
  height: 0.125rem;
  background-color: #fff;
}

.button_page_des {
  font-weight: 400;
  color: #ffffff;
  font-size: 1rem;
  padding: 2.0625rem;
  display: flex;
  position: absolute;
  top: 23.5rem;
  justify-content: center;
}

.button_page_button {
  border: none;
  width: 7.75rem;
  height: 2.75rem;
  background: #ffffff;
  border-radius: 1.375rem;
  margin-top: 2.5rem;
  /* display: flex; */
  position: absolute;
  top: 36rem;
  margin: 1.25rem;
  justify-content: center;
}

.button_page_button:hover {
  cursor: pointer;
}

/* 证书模块 */
.certificate_page {
  position: relative;
  overflow: hidden;
  height: 50rem;
  background-image: url(../assets/img/bg_zhengshu.png);
  background-repeat: no-repeat;
  background-size: cover;
}

.certificate_box {
  position: relative;
  width: 100%;
  height: 46.0625rem;
  margin-top: 5.125rem;
  margin-left: 15rem;
}

.certificate_en_title {
  font-size: 1.875rem;
  color: #999999;
}

.certificate_img_box {
  width: 12.5rem;
  height: 9.375rem;
}

.certificate_cn_title {
  font-size: 3rem;
  color: #333333;
  margin-bottom: 3.625rem;
}

.certificate_des {
  margin-top: 2rem;
  font-size: 1.5rem;
  color: #999999;
}

.certificates {
  position: absolute;
  top: 3.125rem;
  width: 62.5rem;
  height: 43.75rem;
  right: 20rem;
}

.row {
  float: right;
  margin: -0.575rem;
  width: 13rem;
  height: 10rem;
}

.friend_el-image {
  width: 80%;
  height: 80%;
  border: 0.1875rem solid #1f1f1f;
}

.row1 {
  height: 10.625rem;
  width: 100%;
  margin-bottom: 0.875rem;
}

.row2 {
  height: 10.625rem;
  margin-top: 1rem;
  width: 100%;
  margin-bottom: 0.875rem;
}

.row3 {
  height: 18.125rem;
  width: 100%;
}
.row_tall {
  height: 12.125rem;
  width: 9rem;
  float: right;
  margin: 1.425rem;
  margin-top: 0px;
}
.row_tall_img {
  width: 100%;
  height: 100%;
  border: 0.1875rem solid #1f1f1f;
}
/* 合作伙伴 */
.friends {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.friends_box {
  display: flex;
  flex-wrap: wrap;
  width: 70rem;
  justify-content: start;
  margin: 3.5rem 1.875rem;
}

.friend_base {
  margin: 0.625rem;
  box-shadow: 0px 0.25rem 0.75rem 0px rgba(0, 0, 0, 0.24);
  border-radius: 0.25rem;
}

.friend_sort {
  width: 12.4375rem;
  height: 7.1875rem;
}

.friend_sort_img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.friend_long {
  width: 26.5rem;
  height: 7.1875rem;
}

.hainan {
  width: 34rem;
  height: 7.1875rem;
}

.foshan {
  width: 20rem;
  height: 7.1875rem;
}

/* 新闻资讯 */
.news {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.new {
  display: flex;
  margin-top: 2rem;
  cursor: pointer;
}

.news_box {
  display: flex;
  margin-top: 3rem;
  margin-bottom: 4rem;
}

.box_left,
.box_right {
  margin-left: 2.5rem;
}

.news_option {
  font-size: 1.5rem;
  font-weight: 400;
  color: #333333;
}

.news_option:hover {
  cursor: pointer;
}

.news_imgbox {
  width: 11.375rem;
  height: 7.5rem;
}

.news_content {
  margin-left: 1rem;
}

.news_img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.news_title {
  font-size: 1.1rem;
  font-weight: 520;
  color: #333333;
  margin-bottom: 6px;
}

.news_des {
  width: 25rem;
  font-size: 0.75rem;
  color: #999999;
  overflow: hidden;

  text-overflow: ellipsis;

  display: -webkit-box;

  -webkit-line-clamp: 3;

  -webkit-box-orient: vertical;
}

/* 公司荣誉 */
.honor_title {
  position: absolute;
  left: 5.6rem;
  top: 5.5rem;
}
.honor_page {
  position: relative;
  overflow: hidden;
  background-image: url(../assets/img/bg_honor.png);
  background-repeat: no-repeat;
  background-size: cover;
}

.honors {
  margin-top: 14rem;
  height: 37rem;
}

.honor1 {
  display: flex;
  position: absolute;
  top: -6.6rem;
  left: 40%;
  z-index: 2;
  width: 54rem;
  height: 6.9rem;
}

.honor2 {
  display: flex;
  position: absolute;
  top: -6.6rem;
  left: 34%;
  width: 54rem;
  height: 6.9rem;
}

.honor3 {
  display: flex;
  position: absolute;
  top: -6.6rem;
  left: 29%;
  width: 54rem;
  height: 6.9rem;
}

.honor4 {
  display: flex;
  position: absolute;
  top: -10.5rem;
  left: 24%;
  width: 96rem;
  height: 11rem;
}

.rows {
  position: relative;
  height: 30%;
}

.row1_img {
  position: absolute;
  right: 0;
  width: 68.3%;
}

.row2_img {
  float: right;
  width: 75.3%;
}

.row3_img {
  float: right;
  width: 80%;
}

.row4_img {
  float: right;
  width: 84.1%;
}

.row1_imgbox {
  margin-right: 2.5%;
  width: 10rem;
}

.row1_imgbox_img {
  width: 100%;
  height: 100%;
}

.row4_imgbox {
  margin-right: 1.5%;
  border: 5px solid #511d1e;
}

.honor_tall_img {
  width: 100%;
  height: 100%;
}

.click_box {
  margin-top: -21px;
  margin-left: 2px;
  width: 20px;
  height: 20px;
}

.click_box img {
  width: 100%;
  height: 100%;
}

.call {
  display: flex;
  justify-content: space-around;
  overflow: hidden;
  height: 12.125rem;
  background-image: url(../assets/img/1920x242_kefu.png);
  background-repeat: no-repeat;
  background-size: cover;
}

.callleft_content {
  width: 30rem;
  margin-top: 2.2rem;
}

.callright_content {
  margin-top: 2.2rem;
}

.call_title {
  font-size: 2rem;
  color: #ffffff;
}

.call_button {
  margin-top: 2.5rem;
  width: 10rem;
  height: 3.5rem;
  border-radius: 1.875rem;
  border: 0.0625rem solid #ffffff;
}

.call_left_button {
  font-weight: 500;
  color: #13489d;
  background: linear-gradient(180deg, #ffffff 0%, #ceedfb 100%);
}

.call_right_button {
  color: #ffffff;
  background-color: transparent;
  border: 0.0625rem solid #ffffff;
}
.more {
  cursor: pointer;
  margin-bottom: 4rem;
}
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 14px;
}
</style>
